import React from "react";
import { Grid, Stack, TextField, Typography } from "@mui/material";

interface LabeledTextAreaProps {
  label: string;
  // Widened beyond `string`: several callers hydrate this straight from API
  // responses where an unanswered field comes back as `null`/`undefined`.
  value: string | null | undefined;
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  placeholder?: string;
  multiline?: boolean;
  minRows?: number;
  helperText?: string;
  name?: string;
  onBlur?: React.FocusEventHandler;
  disabled?: boolean;
}

export const LabeledTextArea: React.FC<LabeledTextAreaProps> = ({
  label,
  value,
  onChange,
  placeholder,
  multiline = false,
  minRows = 1,
  helperText,
  name,
  onBlur,
  disabled,
}) => {
  return (
    <Grid item xs={12}>
      <Stack gap={1}>
        <TextField
          label={label}
          placeholder={placeholder}
          multiline={multiline}
          minRows={multiline ? minRows : undefined}
          value={value ?? ""}
          onChange={onChange}
          fullWidth
          name={name}
          onBlur={onBlur}
          disabled={disabled}
          sx={
            multiline
              ? {
                  fieldSizing: "content",
                  "& textarea": { whiteSpace: "pre-wrap" },
                }
              : undefined
          }
        />
        {helperText && (
          <Typography
            variant="inputLabel"
            sx={{ color: "var(--grey-600, #798397)", fontWeight: 400 }}
          >
            {helperText}
          </Typography>
        )}
      </Stack>
    </Grid>
  );
};

export default LabeledTextArea;
